import { render, staticRenderFns } from "./PartnerStatute.vue?vue&type=template&id=17abc45d&"
import script from "./PartnerStatute.vue?vue&type=script&lang=ts&"
export * from "./PartnerStatute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports